const states = {
    noSave: false,
    showWallet: null,
    showCardForm: false,
    card: null,
    captcha: { current: null },
    captchaToken: '',
    onError: null,
    onSelect: null,
    paymentType: '',
    t: null,
    mutate: null,
    testCard: false,
};
export default states;
